import { render, staticRenderFns } from "./SituationTypesSelector.vue?vue&type=template&id=4d13cc1c"
import script from "./SituationTypesSelector.vue?vue&type=script&lang=js"
export * from "./SituationTypesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports